<template>
	<div id="vue_bookingform" class="booking-receipt__data bookinbar_wrap" v-bind:class="{focus_inside: hasAttention, loading: currentlyLoading}" :data-error="errorClasses.join(' ')">

		<Destination ref="destination" @opened="getAttention" @error="showError" @focus="closeDropDowns" />

		<Dates ref="dates" @opened="getAttention" @error="showError" @focus="closeDropDowns" />

		<Rate ref="rate" @opened="getAttention" @focus="closeDropDowns" />

		<Rooms ref="rooms" @opened="getAttention" @focus="closeDropDowns" />

		<Code ref="code" @opened="getAttention" @focus="closeDropDowns" v-if="!isMobile" />

		<Guests ref="guests" @opened="getAttention" @focus="closeDropDowns" />

		<Code ref="code" @opened="getAttention" @focus="closeDropDowns" v-if="isMobile" />

		<button id="availabilityButton" class="button" type="submit" v-bind:readonly="!hasDestination" v-bind:disabled="!hasDestination" v-bind:aria-disabled="!hasDestination">{{ this.$store.state.continueButtonText }}</button>
	</div>
</template>

<script>
import Destination from './components/Destination'
import Dates from './components/form/Dates'
import Guests from './components/form/Guests'
import Rooms from './components/form/Rooms'
import Rate from './components/form/Rate'
import Code from './components/form/Code'
import moment from 'moment/src/moment'


export default {
	name: 'Bookingform',
	components: {
		Destination,
		Guests,
		Rooms,
		Rate,
		Code,
		Dates
	},
	data: function(){
		return {
			hasAttention: false,
			errorClasses: [],
			isMobile: false,
		}
	},
	mounted() {
		let initData = false

		// set inital dates?!
		if(this.$store.state.arrival && this.$store.state.departure) {
			initData = true
			const arrival = this.$store.state.arrival ? moment(this.$store.state.arrival).format(this.$store.state.dateFormat) : moment().format(this.$store.state.dateFormat)
			const departure = this.$store.state.departure ? moment(this.$store.state.departure).format(this.$store.state.dateFormat) : moment().add(1, 'day').format(this.$store.state.dateFormat)

			this.$store.commit('setArrival', arrival)
			this.$store.commit('setDeparture', departure)
		} else {
			this.$store.dispatch('traveldates', {})
		}

		// initial rate and/or code
		if(this.$store.state.rate_code) {
			initData = true
			const newRate = this.$store.state.rates.filter(rate => rate.code == this.$store.state.rate_code)
			this.$store.commit('setRate', newRate.shift())
		}
		if(this.$store.state.promo_code) {
			initData = true
			this.$store.commit('setPromo', this.$store.state.promo_code)
		}

		// set initial destination
		if(this.$store.state.where) {
			initData = true
			this.$store.dispatch('selectDestination', this.$store.state.where)

			const selectedDestination = [... this.$store.state.destinations].concat(this.$store.state.hotels).filter(dest => dest.id == parseInt(this.$store.state.where))

			// reset availability
			this.$store.commit('setAvailability', {})
			if(selectedDestination.length) {
				this.$store.commit('setDestination', { destination: selectedDestination.shift() })
			}
		}

		if(initData) {
			this.$store.dispatch('loadAvailability')
		}

		window.addEventListener('resize', this.updateMobile);
		this.updateMobile();

		this.$store.subscribe((mutation) => this.validateUserInput(mutation))
	},
	computed: {
		currentlyLoading: function () {
			return this.$store.state.currentlyLoading
		},
		errorShowTime: function () {
			return this.$store.state.errorShowTime
		},
		hasDestination: function (){
			return !this.currentlyLoading && !!this.$store.state.destination
		},
	},
	methods: {
		updateMobile() {
			this.isMobile = (window.innerWidth < this.$store.state.mobileBreakpoint);
		},
		getAttention() {
			this.hasAttention = true
			//document.getElementById('vue_bookingbar').parentElement.parentElement.classList.add('focus_inside')
		},
		looseAttention() {
			this.hasAttention = false
			this.closeDropDowns()
			//document.getElementById('vue_bookingbar').parentElement.parentElement.classList.remove('focus_inside')
		},
		showError(error) {
			const that = this
			this.errorClasses.push(error)

			setTimeout(function(){
				const index = that.errorClasses.indexOf(error);
				if (index > -1) {
					that.errorClasses.splice(index, 1);
				}
			}, this.errorShowTime)
		},

		closeDropDowns() {
			// close the other dropdowns
			this.$refs.destination.hideDestinationDropdown()
			this.$refs.dates.closePicker()
			this.$refs.guests.hideDropdown()
			this.$refs.rooms.hideDropdown()
			this.$refs.rate.hideDropdown()
		},

		validateUserInput(mutation) {

			let filteredDestinations, filteredHotels, filteredRates;


			switch(mutation.type) {
				case 'updateDestinations':
				case 'updateHotels':
					if(this.$store.state.destination) {
						filteredDestinations = this.$store.state.destinations.filter(r => r.id == this.$store.state.destination.id)
						filteredHotels = this.$store.state.hotels.filter(r => r.id == this.$store.state.destination.id)
						if (!filteredHotels.length && !filteredDestinations.length) {
							this.$store.commit('setDestination', { destination: null })
							this.showError('destination_destination_notavailable')
						}
					}
					break
				case 'updateRates':
					if(this.$store.state.rate) {
						filteredRates = this.$store.state.rates.filter(r => r.code == this.$store.state.rate.code)
						if (!filteredRates.length) {
							this.$store.dispatch('clearRate')
							this.showError('rate_notavailable')
						}
					}
					break
				default:
					return
			}
		}
	}
}
</script>